module.exports = __webpack_public_path__ + "media/images/new_marketing/spiral-up-app-3d8db5e1fa90bbc11740741ff1c3ead602d7d050c65c89a59fc0974cbb9d963b.jpeg";